<template>
  <v-footer dark padless class="linear" color="">
    <v-container class="py-0 transparent">
      <v-card
        :min-height="$vuetify.breakpoint.smAndUp ? 150 : 260"
        class="flex transparent"
        flat
        tile
      >
        <v-card-title class="">
          <v-row>
            <v-col cols="12" md="6" class="text-center">
              <strong style="word-break: break-word" class="subheading"
                >Get connected with us on social networks!
              </strong>
            </v-col>
            <v-col cols="12" md="6" class="d-flex align-center justify-center">
              <div class="btn_group">
                <span v-for="(icon, i) in items.slice(2, 6)" :key="i">
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      class="mx-2"
                      dark
                      :color="hover ? icon.color : '#3d4b5e'"
                      target="_blank"
                      :href="icon.link"
                      icon
                    >
                      <v-icon size="24px">
                        {{ icon.icon }}
                      </v-icon>
                    </v-btn>
                  </v-hover>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2 white--text text-center">
          <span class="special_font">{{ new Date().getFullYear() }}</span> —
          Made by<strong
            style="color: #cb834a; font-family: monospace; font-size: large"
            class="special_font"
          >
            Mohammed Fawzey</strong
          >
        </v-card-text>
      </v-card>
    </v-container>
  </v-footer>
</template>

<script>
import data from "@/db/data.json";
export default {
  data: () => ({
    items: data.socials,
    links: ["MovieHunter", "explore", "DMCA", "AD-P", "Hunter news"],
  }),
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;500;600;700&display=swap");
* {
  font-family: "Cairo", sans-serif;
}
.linear {
  // background: linear-gradient(to bottom right, rgb(69, 80, 96), #111722);
  background: linear-gradient(to top left, #10121deb, #111722);
}
</style>
